import './ErrorsSection.scss';

import React, { useCallback } from 'react';

import ClipboardButton from '../../../../../../common/ClipboardButton';
import bem from '../../../../../../utils/bem';
import type { ErrorItem } from '../../types';
import { CLIPBOARD_TOOLTIP_MESSAGE, ERRORS_BLOCK_TITLE } from '../constants';
import ErrorsList from './ErrorsList/ErrorsList';
import { copyErrorsToClipboard } from './utils';

export type ErrorsSectionProps = {
  errorItems: ErrorItem[];
};

const [block, element] = bem('errors-section');

const ErrorsSection = ({ errorItems }: ErrorsSectionProps): React.JSX.Element => {
  const onHandleCopy = useCallback((): Promise<void> => copyErrorsToClipboard(errorItems), [errorItems]);

  return (
    <div className={block()} data-testid="errors-section">
      <div className={element('block-text-wrapper')}>
        <div className={element('block-text')}>{ERRORS_BLOCK_TITLE}</div>
        <ClipboardButton copyText={onHandleCopy} tooltipText={CLIPBOARD_TOOLTIP_MESSAGE} />
      </div>
      <div className={element('block-content-errors')}>
        <ErrorsList errorItems={errorItems} />
      </div>
    </div>
  );
};

export default ErrorsSection;
